<script>
export default {
    name: "publish-jump-to-date-button",
    emits: ['dateSelected'],
    props: {
        events: Array
    },
    data() {
        return {
            showMenu: false,
        }
    },
    computed: {
        tLabel() {
            return Lang.langGet('Jump To Date');
        },
        calendarEvents() {
            return this.events.map(event => {
                const date = new Date(event.start);
                return date.toISOString().substr(0, 10);
            });
        },
        locale() {
            return Laravel.activeLanguage;
        }
    },
    methods: {
        handleDateSelect(date) {
            this.showMenu = false;
            this.$emit('dateSelected', date);
        }
    }
}
</script>

<template>
    <v-menu
        v-model="showMenu"
        :close-on-content-click="false"
        content-class="menu-rounded"
        transition="scroll-y-reverse-transition"
        max-width="290px"
    >
        <template #activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                @click="showMenu = true"
            >
                <v-icon left>far fa-calendar</v-icon>
                {{tLabel}}
            </v-btn>
        </template>

        <v-date-picker
            :events="calendarEvents"
            event-color="blue"
            :locale="locale"
            aria-label="datepicker"
            color="primary"
            no-title
            show-adjacent-months
            @input="handleDateSelect"
        />
    </v-menu>
</template>

<style>
.v-date-picker-table__events {
    .blue {
        background-color: var(--color-primary) !important;
        border-color: var(--color-primary) !important;
    }
}
</style>
